module.exports = __webpack_public_path__ + "img/edit.b9086eab.svg";